module.exports = __webpack_public_path__ + "static/media/Fashioncup.954ccc87.png";